export default "__VITE_ASSET__0ae25a3b__"